import { Form, Input, Select, Skeleton } from 'antd'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { HelpDrawer } from '../Generics/help-drawer'
import { UtilsContext } from '@BUP/contexts/utils-context'

export function ComplaintFormInputs () {
  const i18n = useTranslation()
  const { data, isLoading } = useContext(UtilsContext)
  const [open, setOpen] = useState(false)
  const showTooltip = () => setOpen(true)
  const closeTooltip = () => setOpen(false)

  return (
    <Skeleton active loading={isLoading}>
      <Form.Item
        name='title'
        label={i18n.t('common.resources.complaint.attributes.title.label')}
        rules={[{ required: true, message: i18n.t('common.resources.complaint.attributes.title.validations.required') }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name='infractionLevel'
        label={i18n.t('common.resources.complaint.attributes.infraction-level.label')}
        rules={[{ required: true, message: i18n.t('common.resources.complaint.attributes.infraction-level.validations.required') }]}
      >
        {data && (
          <Select
            options={data.complaint.infractionLevels.map(infractionLevel => ({ value: infractionLevel, label: i18n.t(`common.resources.complaint.values.infraction-level.${infractionLevel}.label`) }))}
          />
        )}
      </Form.Item>
      <Form.Item
        initialValue={i18n.t('common.resources.complaint.attributes.description.template')}
        name='description'
        label={i18n.t('common.resources.complaint.attributes.description.label')}
        rules={[{ required: true, message: i18n.t('common.resources.complaint.attributes.description.validations.required') }]}
        tooltip={{ open: false, onClick: showTooltip }}
      >
        <Input.TextArea style={{ fontFamily: 'monospace' }} autoSize={{ minRows: 10, maxRows: 30 }} />
      </Form.Item>
      <HelpDrawer prefix='common.resources.complaint.attributes.description' title={i18n.t('common.resources.complaint.attributes.description.label')} open={open} onClose={closeTooltip} />
    </Skeleton>
  )
}
